/**
 * Signature gold corner brackets — warm champagne detail for cards/images.
 * Apply inside any `relative` container. Use `inset` for position (default -2px).
 */
export default function GoldCorners({ size = 10, color = "#C7A26C", inset = -2 }) {
  const base = {
    position: "absolute",
    backgroundColor: color,
    pointerEvents: "none",
  };
  const i = `${inset}px`;
  const h = `${size}px`;
  const w1 = "1px";
  return (
    <>
      {/* top-left */}
      <span style={{ ...base, top: i, left: i, width: h, height: w1 }} />
      <span style={{ ...base, top: i, left: i, width: w1, height: h }} />
      {/* top-right */}
      <span style={{ ...base, top: i, right: i, width: h, height: w1 }} />
      <span style={{ ...base, top: i, right: i, width: w1, height: h }} />
      {/* bottom-left */}
      <span style={{ ...base, bottom: i, left: i, width: h, height: w1 }} />
      <span style={{ ...base, bottom: i, left: i, width: w1, height: h }} />
      {/* bottom-right */}
      <span style={{ ...base, bottom: i, right: i, width: h, height: w1 }} />
      <span style={{ ...base, bottom: i, right: i, width: w1, height: h }} />
    </>
  );
}
